import './Logo.css'
import LogoImg from './logo.png'

interface LogoProps {
  showTitle?: boolean
  className?: string
  titleClassName?: string
  iconClassName?: string
}

export function Logo({
  showTitle = true,
  className = '',
  titleClassName = '',
  iconClassName = '',
}: LogoProps) {
  return (
    <div className={`logo-section ${className}`}>
      <img
        src={LogoImg}
        alt="Wishlist"
        className={`app-icon ${iconClassName}`}
      />
      {showTitle && (
        <h2 className={`logo-title ${titleClassName}`}>Wishlist Admin</h2>
      )}
    </div>
  )
}
